import React from 'react'

interface IProps {
    errorMessage?: string
    assistiveText?: string
    required?: boolean
}

const FieldErrorSection = (props: IProps) => {
    const { errorMessage, assistiveText, required } = props

    return (
        <>
            {errorMessage ? (
                <p className="error-text small">{errorMessage}</p>
            ) : (
                <p className="assistive-text small">
                    {assistiveText !== undefined ? assistiveText : required ? 'Required' : 'Optional'}
                </p>
            )}
        </>
    )
}

export default FieldErrorSection
